<template>
  <div class="calculatecode">
    <a-card>
      <a-form-model layout="inline">
        <a-form-model-item label="游戏名称">
          <a-input placeholder="请输入游戏名称" allow-clear :maxLength="20" v-model="search.ContentName" @keyup.enter="getList(1)" />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-input placeholder="请输入" allow-clear :maxLength="30" v-model="search.remark" @keyup.enter="getList(1)" />
        </a-form-model-item>
        <a-form-model-item label="算分码">
          <a-input placeholder="请输入" allow-clear :maxLength="20" v-model="search.code" @keyup.enter="getList(1)" />
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="getList(1)">查询</a-button>
          <a-button style="margin: 0 35px 0 15px" @click="resetSearch()">重置</a-button>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="add()" icon="plus" v-permission="`Content.AlgorithmCode.Add`">添加算分码</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="table">
        <a-table
          class="components-table-demo-nested"
          :columns="columns"
          rowKey="id"
          :loading="loading"
          :dataSource="dataSource"
          @expandedRowsChange="expandedRowsChange"
          :expandedRowKeys="tableExpandedRowKeys"
          @expand="expand"
          :pagination="{
            current: search.PageIndex,
            pageSize: search.PageSize,
            total: total,
            showSizeChanger: true,
            showLessItems: true,
            showQuickJumper: true,
            showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
            onChange: onPageChange,
            onShowSizeChange: onSizeChange,
          }"
        >
          <div slot="action" slot-scope="text, record">
            <a @click="edit(record)" style="margin-right: 8px" v-permission="`Content.AlgorithmCode.Edit`"> <a-icon type="edit" />编辑 </a>
            <a-popconfirm title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="deleteRecord(record)" v-permission="`Content.AlgorithmCode.Delete`">
              <a style="color: #f00; margin-right: 8px"> <a-icon type="delete" />删除 </a>
            </a-popconfirm>
          </div>
          <div slot="expandedRowRender" slot-scope="record">
            <div class="t_bot">
              <span v-for="item in record.gameList" :key="item.id">{{ item.name }}{{ item.versionName ? ' - ' + item.versionName : '' }}</span>
              <span v-if="!record.gameList.length">暂无关联内容</span>
            </div>
          </div>
        </a-table>
      </div>
      <!-- 编辑添加 -->
      <a-modal v-model="ismodle" :title="modleTit" :centered="true" @ok="modleOk">
        <a-form-model ref="ruleForm" :model="modleForm" :rules="modleRules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
          <a-form-model-item ref="code" label="算分码" prop="code">
            <a-input v-model="modleForm.code" :disabled="isEdit" :maxLength="50" />
          </a-form-model-item>
          <a-form-model-item ref="remark" label="备注">
            <a-input v-model="modleForm.remark" type="textarea" :maxLength="500" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
const columns = [
  { title: '算分码', dataIndex: 'code' },
  { title: '备注', dataIndex: 'remark', align: 'center', ellipsis: true },
  { title: '更新时间', dataIndex: 'updateTime', align: 'center' },
  { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center' },
]
export default {
  name: 'Calculatecode',
  data() {
    return {
      advanced: false,
      istoggleAdvanced: false, //是否显示展开按钮
      columns: columns,
      loading: true,
      dataSource: [],
      dataSource1: [],
      // 搜索表单
      search: {
        PageIndex: 1,
        PageSize: 10,
        ContentName: '', //游戏名称
        remark: '',
      },
      total: 0,
      ismodle: false, //是否显示添加编辑弹窗
      // 添加编辑表单
      modleForm: {
        code: '', //算分码
        remark: '', //备注
        algorithm: 'algorithm',
      },
      // 添加编辑表单校验
      modleRules: {
        code: [{ required: true, message: '请填写算分码', trigger: 'blur' }],
      },
      // 类型  用于区分编辑、添加
      type: '',
      isEdit: false, //编辑时 不允许修改算分码
      modleTit: '', //添加编辑弹窗标题
      tableExpandedRowKeys: [], //表格展开的行
    }
  },
  created() {
    this.getList()
    console.log('更新')
  },
  watch: {
    ismodle() {
      if (!this.ismodle) {
        this.$refs.ruleForm.resetFields()
        this.isEdit = false
      }
    },
  },
  methods: {
    // 展开行
    expandedRowsChange(expandedRowKeys) {
      if (expandedRowKeys.length > 1) {
        this.tableExpandedRowKeys = [expandedRowKeys.pop()]
      } else {
        this.tableExpandedRowKeys = expandedRowKeys
      }
    },
    // 根据code 获取关联游戏
    expand(expanded, record) {
      if (expanded) {
        let params = {
          code: record.code,
        }
        this.$http.getContentsByCode(params).then((res) => {
          record.gameList = res.data.data
        })
      }
    },
    // 添加算分码
    add() {
      this.modleForm = {
        code: '',
        remark: '',
        algorithm: 'algorithm',
      }
      this.type = 'add'
      this.ismodle = true
      this.modleTit = '添加'
    },
    // 编辑算分码
    edit(record) {
      localStorage.setItem('calculateCodeItem', JSON.stringify(record))
      this.modleTit = '编辑'
      this.type = 'edit'
      this.modleForm.code = record.code
      this.modleForm.remark = record.remark
      this.modleForm.oldCode = record.code
      this.ismodle = true
      this.isEdit = true
    },
    // 添加编辑弹窗确定按钮
    modleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.addCalculateCode()
          } else {
            this.editCalculateCode()
          }
        } else {
        }
      })
    },
    // 添加算分码方法
    addCalculateCode() {
      this.$http.addAlgorithmCode(this.modleForm).then((res) => {
          this.$message.success('添加成功')
          this.getList()
          this.ismodle = false
       
      })
    },
    // 编辑算分码方法
    editCalculateCode() {
      this.$http.editAlgorithmCode(this.modleForm).then((res) => {
          this.$message.success('修改成功')
          this.getList()
          this.ismodle = false
      })
    },
    // 切换页码
    onPageChange(page, size) {
      this.search.PageIndex = page
      this.tableExpandedRowKeys = []
      this.getList()
    },
    // 切换条数
    onSizeChange(page, size) {
      this.tableExpandedRowKeys = []
      this.search.PageIndex = 1
      this.search.PageSize = size
      this.getList()
    },
    getList(page) {
      this.tableExpandedRowKeys = []
      if (page) {
        this.search.PageIndex = page
      }
      this.$http
        .AlgorithmCodePageList(this.search)
        .then((res) => {
          this.dataSource = res.data.data.items.map((v) => ({ ...v, gameList: [] }))
          this.total = res.data.data.totalCount
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    // 删除
    deleteRecord(record) {
      let formData = new FormData()
      formData.append('code', record.code)
      this.$http.deleteAlgorithmCode(formData).then((res) => {
        this.$message.success(res.data.message)
        ;(this.PageIndex = 1), this.getList()
      })
    },
    resetSearch() {
      this.search = {
        PageIndex: 1,
        PageSize: 10,
        ContentName: '',
        code: undefined,
      }
      this.getList()
    },
  },
}
</script>

<style lang="less" scoped>
// @import "index";
.searchForm {
  display: flex;
  justify-content: space-between;
}

.fold {
  display: flex;
  align-items: center;
}

.t_top {
  display: flex;
  align-items: center;
}

.t_bot {
  span {
    margin-right: 25px;
    display: inline-block;
  }
}

.table {
  margin-top: 24px;
}

.addBtn {
  margin-left: 45px;
}
</style>
